import { UserInfo } from '@/views/userInfo/user-info-reference/types'

export interface State {
  total_count: number
  detail: Array<DetailType>
  userParams: Params
  userInfoDetail: UserInfo
  isEditModel: boolean
  isAddModel: boolean
}
export interface DetailType {
  employee_code: string
  name: string
  department: string
  role_name: string
  insert_datetime: string
}
export interface Params {
  sort_column: string
  sort: string
  page_size: number
  page_number: number
}

const state = (): State => ({
  total_count: 0,
  detail: [],
  userParams: {
    sort_column: 'SORT_DEFAULT',
    sort: 'ASC',
    page_size: 20,
    page_number: 1,
  },

  isEditModel: false,
  isAddModel: false,

  userInfoDetail: {
    user_id: '',
    family_name: '',
    given_name: '',
    email: '',
    employee_code: '',
    department: '',
    insert_datetime: '',
    role_code: '',
    role_name: '',
    corporate_id: -1,
    corporate_number: '',
    corporate_name: '',
    plan_category: '',
    default_corporate_flag: '0',
    chem_value_contract_flag: '0',
    chem_value_usage_flag: '0',
    direct_corporate_number: '',
    direct_corporate_name: '',
  } as UserInfo,
})

export default state
